import {RadioCheckButton, ForwardsBackwardsBar, BarButton, HeaderBig, ProgressBar, DropdownMenu, TextInput, TextInputMultiline, HelpBtn, CloseButtonBig, DateInput, MailIinput, HeaderWithButton, Popup, ClosePopup, SquareButton, LeavePrompt, DropdownMenuWithManualError, NavigateSmart, TelNoInputNew, LinkSmart} from '../common/Common';
import {useState, useRef, useContext, useEffect, useLayoutEffect, useTransition} from "react";
import './CollectData.css';
import {Link, Navigate, Route, Routes, useLocation, useSearchParams} from 'react-router-dom'
import { LocaleContext, LoginContext, OverlayContext, ScrollContext, StateContext } from '../common/App';
import { postWithCsrf, get_translation_objects, checkEmail, get_translated_notifications, logout, logoutConsumer, checkMinMaxDate, checkLanguageLevel, getDisplayLanguage } from '../common/util';
import {UserType, NoOfChildren, AgeOfChildren, AvailabilityTime, WeekDays, Start, Notifications, AvailabilityByPhone, Recommendation, Gender, GenderNanny, Salutation, Title, Location, Graduation, Language, LanguageLevel, MediationStatus, LoadState, TwoFactorAuthType, DisplayLanguage} from '../common/enums.mjs';
import { LanguagesSelect } from '../common/LanguagesSelect';
import { ConsumerContext } from '..';
import { AddButton } from '../common/Common';
import { RemoveButton } from '../common/Common';
import { AgeOfChildrenFamSelect } from '../common/Common';
import { maxCustomerCommentLength, maxLanguagesFamily, maxLanguagesNanny, maxSpecialCareTextLength } from '../common/globals.mjs';
import { validateCity, validateComment, validateCurrentEmployment, validateCustomerComment, validateName, validatePhoneNumber, validatePostCode, validateSpecialCareText, validateSpecificAvailabilityByPhone, validateStreetAndHouseNo } from '../common/validate';
import { maxCityLength, maxCurrentEmploymentLength, maxNameLength, maxPhoneNoLength, maxPostCodeLength, maxSpecificAvailabilityByPhoneLength, maxStreetAndHouseNoLength, maxUsernameLength } from '../common/globals_common.mjs';
import { useNavigateSmart } from '../common/hooks';

export function CollectData(props) {
    const navigate = useNavigateSmart();
    const location = useLocation();
    const scrollDummyRef = useRef();
    const scrollRef = useRef();
    const collectDataBoxRef = useRef();
    const dataNavRef = useRef();

    const login = useContext(LoginContext);
    const state = useContext(StateContext);
    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);
    const overlay = useContext(OverlayContext);
    const consumer = useContext(ConsumerContext);

    const [searchParams, setSearchParams] = useSearchParams();

    let backwardsClickable = true;
    let forwardsClickable = true;
    let backwardsVisible = true;
    let forwardsVisible = true;
    let forwardsText = locale.msgs.CONTINUE;
    

    // States:

    const [collectDataNavWidth, setCollectDataNavWidth] = useState(0);
    const [endDummyHeight, setEndDummyHeight] = useState(0);
    const [closePopupDisaplyed, setClosePopupDisaplyed] = useState(0);

    const [loadState, setLoadState] = useState(LoadState.NONE);

    const userType = {
        "user_type": login.userType
    };

    let obj = loadFromLocalStorage("data");
    let [data, setData] = useState(obj != null ? obj : {

        // Common (for nanny and family)
        "salutation": Salutation.NONE,
        "title": Title.NONE,
        "first_name": "",
        "last_name": "",
        "phone_number": "",
        "city": "",
        "post_code": "",

        // Only for nanny
        "birth_date": "",
        "gender": Gender.NONE,
        "graduation": Graduation.NONE,
        "current_employment": "",
        "street_and_house_no": ""
    });

    obj = loadFromLocalStorage("no_of_children");
    let [noOfChildren, setNoOfChildren] = useState(obj != null ? obj : {
        "no_of_children": NoOfChildren.NONE
    });

    // Only for mn
    obj = loadFromLocalStorage("age_of_children");
    let [ageOfChildren, setAgeOfChildren] = useState(obj != null ? obj : {
        "age_of_children": AgeOfChildren.NONE,
        "age_of_children_specific_1-2": false,
        "age_of_children_specific_3-6": false,
        "age_of_children_specific_>6": false,
    });

    // Only for family
    obj = loadFromLocalStorage("age_of_children_fam");
    let [ageOfChildrenFam, setAgeOfChildrenFam] = useState(obj != null ? obj : {
        "age_of_children_fam": []
    });

    obj = loadFromLocalStorage("time_info");
    let [timeInfo, setTimeInfo] = useState(obj != null ? obj : {
        "availability_time": AvailabilityTime.NONE,
        "week_days": WeekDays.NONE,
        "week_days_specific_monday": false,
        "week_days_specific_tuesday": false,
        "week_days_specific_wednesday": false,
        "week_days_specific_thursday": false,
        "week_days_specific_friday": false,
        "week_days_specific_saturday": false,
        "week_days_specific_sunday": false,
    });

    obj = loadFromLocalStorage("start_info");
    let [startInfo, setStartInfo] = useState(obj != null ? obj : {
        "start": Start.NONE,
        "start_specific": ""
    });

    obj = loadFromLocalStorage("skills");
    let [skills, setSkills] = useState(obj != null ? obj : {

        // Common (for nanny and family)
        "drivers_license": false,
        "drive_foreign_car": false,
        "homework_support": false,
        "first_aid_course_for_children": false,
        "pets_are_ok": false,
        "musically": false,
        "cooking": false,

        // Only for family
        "language": false,
        "language_specific": Language.NONE,
        "special_care": false,
        "special_care_text": ""
    });
    let [specialCareTextError, setSpecialCareTextError] = useState(false);

    obj = loadFromLocalStorage("languages");
    let [languages, setLanguages] = useState(obj != null ? obj : {
        "languages": [
            {"language": Language.NONE, "language_level": LanguageLevel.NONE}
        ]
    });

    obj = loadFromLocalStorage("comment");
    let [comment, setComment] = useState(obj != null ? obj : {
        "comment": ""
    });
    let [commentError, setCommentError] = useState(false);

    obj = loadFromLocalStorage("miscellaneous");
    let [miscellaneous, setMiscellaneous] = useState(obj != null ? obj : {
        "notifications": Notifications.NONE,
        "availability_by_phone": AvailabilityByPhone.NONE,
        "specific_availability_by_phone": "",
        "recommendation": Recommendation.NONE,
        "display_language": consumer.displayLanguage
    });

    obj = loadFromLocalStorage("gender_nanny");
    let [genderNanny, setGenderNanny] = useState(obj != null ? obj : {
        "gender_nanny": GenderNanny.NONE
    });


    // FUNCTIONS:

    function getUserTypePrefix(name) {
        let userTypePrefix = "";

        try {
            if(name !== "user_type") {
                userTypePrefix = userType["user_type"] + "_";
            }
        }
        catch(error) {
        }

        return userTypePrefix;
    }

    function saveToLocalStorage(name, obj) {
        localStorage.setItem(getUserTypePrefix(name) + name + "_" + login.username, JSON.stringify(obj));
    }

    function loadFromLocalStorage(name) {
        return JSON.parse(localStorage.getItem(getUserTypePrefix(name) + name + "_" + login.username));
    }

    function deleteAllFromLocalStorage() {
        localStorage.removeItem(UserType.FAMILY + "_user_type" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_data" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_no_of_children" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_age_of_children_fam" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_time_info" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_start_info" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_skills" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_languages" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_comment" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_miscellaneous" + "_" + login.username);
        localStorage.removeItem(UserType.FAMILY + "_gender_nanny" + "_" + login.username);

        localStorage.removeItem(UserType.NANNY + "_user_type" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_data" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_no_of_children" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_age_of_children" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_time_info" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_start_info" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_skills" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_languages" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_comment" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_miscellaneous" + "_" + login.username);
        localStorage.removeItem(UserType.NANNY + "_gender_nanny" + "_" + login.username);
    }

    function createDataObject(props) {
        let obj = {};

        obj = Object.assign(obj, userType);
        obj = Object.assign(obj, data);
        obj = Object.assign(obj, noOfChildren);

        if(userType["user_type"] === UserType.NANNY) {
            obj = Object.assign(obj, ageOfChildren);
        }
        else if(userType["user_type"]  === UserType.FAMILY) {
            obj = Object.assign(obj, ageOfChildrenFam);
        }

        obj = Object.assign(obj, timeInfo);
        obj = Object.assign(obj, startInfo);
        obj = Object.assign(obj, skills);
        obj = Object.assign(obj, languages);
        obj = Object.assign(obj, comment);
        obj = Object.assign(obj, miscellaneous);
        obj = Object.assign(obj, genderNanny);
        
        return obj;
    }

    function handleOnCloseButtonClick() {
        if(location.pathname.endsWith("done/")) {
            navigate("/");
        }
        else {
            setClosePopupDisaplyed(true);
        }
    }

    function handleBackwards(e) {
        scroll.scrollToPlain(0, 0);

        if(location.pathname.endsWith("start_now/")){
            navigate("how_it_works/");
        }
        else if(location.pathname.endsWith("data/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("age_of_children/")){
            navigate("no_of_children/");
        }
        else if(location.pathname.endsWith("age_of_children_fam/")){
            navigate("no_of_children/");
        }
        else if(location.pathname.endsWith("no_of_children/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("time_info/")){
            if(userType["user_type"] === UserType.NANNY) {
                navigate("age_of_children/");
            }
            else {
                navigate("age_of_children_fam/");
            }
        }
        else if(location.pathname.endsWith("start_info/")){
            navigate("time_info/");
        }
        else if(location.pathname.endsWith("skills/")){
            if(userType["user_type"] === UserType.NANNY) {
                navigate("start_info/");
            }
            else {
                navigate("gender_nanny/");
            }
        }
        else if(location.pathname.endsWith("languages/")){
            navigate("skills/");
        }
        else if(location.pathname.endsWith("comment/")){
            navigate("languages/");
        }
        else if(location.pathname.endsWith("miscellaneous/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("done/")){
            setLoadState(LoadState.NONE);
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("collect_data_error/")){
            const errorCode = searchParams.get("status");
            setLoadState(LoadState.NONE);

            /* When adjusting the error code, do not forget to adjust 520 in component CollectDataError */
            if(errorCode == 520) {
                navigate("data/");
            }
            else {
                navigate("start_now/");
            }
        }
        else if(location.pathname.endsWith("gender_nanny/")){
            navigate("start_info/");
        }
    }

    function handleForwards(e) {
        scroll.scrollToPlain(0, 0);

        if(location.pathname.endsWith("how_it_works/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("start_now/")){
            try {
                postWithCsrf("/user/set_data", JSON.stringify(createDataObject()), state).then(response => {
                    if(response.ok) {
                        return response.json();
                    }
                    else {
                        const error = new Error("Response code: " + response.status);
                        error.responseStatus = response.status;
                        throw error;
                    }
                }).then((json) => {
                    setLoadState(LoadState.LOAD_SUCCESS);

                    consumer.setMediationStatus(json.mediation_status);
                    consumer.setDisplayLanguage(json.display_language);
                    login.setNotifications(json.notifications);

                    navigate("done/");
                }).catch(error => {
                    setLoadState(LoadState.NONE); // NONE as we do not want to have an error message on the next page

                    console.log(error);

                    if(error.responseStatus) {
                        navigate("collect_data_error/?status=" + error.responseStatus);
                    }
                    else {
                        navigate("collect_data_error/");
                    }
                });

                // Calling setLoadState() after postWithCsrf() as it could throw an exception
                setLoadState(LoadState.LOADING);
            }
            catch(e) {
                console.log(e);
            }
        }
        else if(location.pathname.endsWith("data/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("no_of_children/")){
            if(userType["user_type"] == UserType.NANNY) {
                navigate("age_of_children/");
            }
            else {
                navigate("age_of_children_fam/");
            }
        }
        else if(location.pathname.endsWith("age_of_children/")){
            navigate("time_info/");
        }
        else if(location.pathname.endsWith("age_of_children_fam/")){
            navigate("time_info/");
        }
        else if(location.pathname.endsWith("time_info/")){
            navigate("start_info/");
        }
        else if(location.pathname.endsWith("start_info/")){
            if(userType["user_type"] === UserType.NANNY) {
                navigate("skills/");
            }
            else {
                navigate("gender_nanny/");
            }
        }
        else if(location.pathname.endsWith("skills/")){
            navigate("languages/");
        }
        else if(location.pathname.endsWith("languages/")){
            navigate("comment/");
        }
        else if(location.pathname.endsWith("comment/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("miscellaneous/")){
            navigate("start_now/");
        }
        else if(location.pathname.endsWith("done/")){
            try {
                logoutConsumer(state, login, consumer).then(() => {
                    setLoadState(LoadState.LOAD_SUCCESS);
                    navigate("/");
                    scroll.scrollToPlain(0, 0);
                }).catch((error) => {
                    console.log(error);
                    setLoadState(LoadState.LOAD_ERROR);
                });

                // Calling setLoadState() after logoutConsumer() as it could throw an exception
                setLoadState(LoadState.LOADING);
            }
            catch(e) {
                console.log(e);
            }
        }
        else if(location.pathname.endsWith("collect_data_error/")){
            try {
                logoutConsumer(state, login, consumer).then(() => {
                    setLoadState(LoadState.LOAD_SUCCESS);
                    navigate("/");
                    scroll.scrollToPlain(0, 0);
                }).catch((error) => {
                    console.log(error);
                    setLoadState(LoadState.LOAD_ERROR);
                });

                // Calling setLoadState() after logoutConsumer() as it could throw an exception
                setLoadState(LoadState.LOADING);
            }
            catch(e) {
                console.log(e);
            } 
        }
        else if(location.pathname.endsWith("gender_nanny/")){
            navigate("skills/");
        }
    }

    // VALIDATE FUNCTIONS START
    
    function validateNoOfChildren() {
        if(noOfChildren["no_of_children"] == ""){
            return false;
        }

        return true;
    }

    function validateAgeOfChildren() {
        if(ageOfChildren["age_of_children"] == "" ||
            (ageOfChildren["age_of_children"] == AgeOfChildren.SPECIFIC && !ageOfChildren["age_of_children_specific_1-2"] && 
            !ageOfChildren["age_of_children_specific_3-6"] && !ageOfChildren["age_of_children_specific_>6"])
        ){
            return false;
        }

        return true;
    }

    function validateAgeOfChildrenFam() {
        if(ageOfChildrenFam["age_of_children_fam"].length === 0) {
            return false;
        }

        for(let i = 0; i < ageOfChildrenFam["age_of_children_fam"].length; i++) {
            const age = ageOfChildrenFam["age_of_children_fam"][i];

            if(age === "") {
                return false;
            }
        }

        return true;
    }

    function validateTimeInfo() {
        let specificWeekDaySelected = timeInfo["week_days_specific_monday"]
            || timeInfo["week_days_specific_tuesday"]
            || timeInfo["week_days_specific_wednesday"]
            || timeInfo["week_days_specific_thursday"]
            || timeInfo["week_days_specific_friday"]
            || timeInfo["week_days_specific_saturday"]
            || timeInfo["week_days_specific_sunday"];

        if((timeInfo["availability_time"] == "") ||
                (timeInfo["week_days"] == WeekDays.NONE) ||
                (timeInfo["week_days"] == WeekDays.SPECIFIC && !specificWeekDaySelected)){
            return false;
        }

        return true;
    }

    function validateStartInfo() {
        if(startInfo["start"] == Start.NONE ||
            (startInfo["start"] == Start.SPECIFIC &&
                (startInfo["start_specific"] === null || startInfo["start_specific"] == "") ||
                 checkMinMaxDate(new Date(startInfo["start_specific"]), {mustBeInFuture: true, maxDaysInFuture: 365}, locale) !== "")){
                 // Check checkMinMaxDate() here again as the current date might have changed
            return false;
        }

        return true;
    }

    function validateSkills() {
        if(userType["user_type"] === UserType.NANNY) {
            return true;
        }

        if((skills["language"] && skills["language_specific"] == Language.NONE) ||
                (skills["special_care"] && (skills["special_care_text"] === null || skills["special_care_text"] == "" ||
                                            !validateSpecialCareText(skills["special_care_text"]) || specialCareTextError
                )) ) {
            return false;
        }

        return true;
    }

    function validateGenderNanny() {
        if(userType["user_type"] === UserType.NANNY) {
            return true;
        }

        if(genderNanny["gender_nanny"] === GenderNanny.NONE) {
            return false;
        }

        return true;
    }

    function validateLanguages() {
        const langList = languages["languages"];

        if(langList.length == 0) {
            return false;
        }

        for(const l of langList) {
            if(l["language"] == Language.NONE || l["language_level"] == LanguageLevel.NONE ||
                    !checkLanguageLevel(l["language_level"])) {
                return false;
            }
        }

        return true;
    }

    function validateUserType() {
        if(userType["user_type"] === UserType.NONE) {
            return false;
        }

        return true;
    }

    function validateData() {
        // Common (for nanny and family)
        if(data["salutation"] === Salutation.NONE ||
            data["first_name"] === null || data["first_name"] === "" || !validateName(data["first_name"]) ||
            data["last_name"] === null || data["last_name"] === "" || !validateName(data["last_name"]) ||
            data["phone_number"] === null || data["phone_number"] === "" || !validatePhoneNumber(data["phone_number"]) ||
            data["city"] === null || data["city"] == "" || !validateCity(data["city"]) ||
            data["post_code"] === null || data["post_code"] === "" || !validatePostCode(data["post_code"]) ||
            data["street_and_house_no"] === null || data["street_and_house_no"] === "" || !validateStreetAndHouseNo(data["street_and_house_no"])
        ){
            return false;
        }

        if(userType["user_type"] === UserType.NANNY) {
            if(data["birth_date"] === null ||
                data["birth_date"] === "" ||
                data["gender"] === Gender.NONE ||
                data["graduation"] === "" ||
                data["current_employment"] === null || data["current_employment"] === "" || !validateCurrentEmployment(data["current_employment"])
            ){
                return false;
            }
        }

        return true;
    }

    function validateWishes() {
        if(!validateNoOfChildren() || !validateStartInfo() || !validateTimeInfo() || !validateSkills() || !validateLanguages() ||
                !validateCustomerComment(comment["comment"]) || commentError) {
            return false;
        }

        if(userType["user_type"] === UserType.NANNY) {
            if(!validateAgeOfChildren()) {
                return false;
            }
        }
        else {
            if(!validateAgeOfChildrenFam() || !validateGenderNanny()) {
                return false;
            }
        }

        return true;
    }

    function validateMiscellaneous() {
        if(/* miscellaneous["notifications"] == Notifications.NONE || */
            miscellaneous["availability_by_phone"] == AvailabilityByPhone.NONE ||
            miscellaneous["recommendation"] == Recommendation.NONE ||
            miscellaneous["display_language"] == DisplayLanguage.NONE ||
            (miscellaneous["availability_by_phone"] == AvailabilityByPhone.SPECIFIC &&
                (miscellaneous["specific_availability_by_phone"] === null || miscellaneous["specific_availability_by_phone"] == "" ||
                 !validateSpecificAvailabilityByPhone(miscellaneous["specific_availability_by_phone"])))
        ){
            return false;
        }

        return true;
    }

    function validateAll() {
        return validateUserType() && validateData() && validateWishes() && validateMiscellaneous();
    }

    // VALIDATE FUNCTIONS END

    function handleScroll(top, bottom) {
        if(window.innerWidth < 450) {
            bottom += dataNavRef.current.clientHeight;
        }

        scroll.scrollTo(top, bottom);
        return;

        const collectDataBoxRect = collectDataBoxRef.current.getBoundingClientRect();
        const scrollEleRect = scrollRef.current.getBoundingClientRect();
        const scrollDummyEleRect = scrollDummyRef.current.getBoundingClientRect();

        // console.log(collectDataBoxRect.top);
        // console.log(scrollEleRect.top);
        // console.log(scrollDummyEleRect.top);

        // console.log("Scroll ele: Top: " + scrollDummyEleRect.top + ", Bottom: " + scrollEleRect.bottom);
        // console.log("Top: " + top + ", Bottom: " + bottom);

        if(top < collectDataBoxRect.top) {
            scrollRef.current.scrollTo(0, top - scrollDummyEleRect.top - 15);
        }

        if(bottom > scrollEleRect.bottom) {
            scrollRef.current.scrollTo(0, bottom - (scrollDummyEleRect.top - collectDataBoxRect.top) - scrollEleRect.bottom + 15);
        }

        //if(bottom)
        // scrollRef.current.scrollTo(0, top - scrollDummyEleRect.top - 20);

            //optionsRef.current.scrollTop = optionsRef.current.scrollHeight;
            //inputRef.current.scrollIntoView({ behavior: 'smooth' });
            //const scrollEle = document.getElementById("collect_data_content");
            //const y = inputRef.current.getBoundingClientRect().top - scrollEle.getBoundingClientRect().top;
            //console.log(inputRef.current.offsetTop);
            //console.log(document.getElementById("header").getBoundingClientRect());
            //console.log(y);
            //scrollEle.scrollTo(0, y);
            //document.querySelector("body").scrollTo(100, 100);
    }

    // function handleUserTypeChange(type) {
    //     setUserType(type);
    //     saveToLocalStorage("user_type", type);
// 
    //     if(type["user_type"] !== userType["user_type"]) {
    //         // deleteAllFromLocalStorage();
    //         // login.setCheckingLogin(true); // Trigger a rerender to reload the data from local storage
    //         props.setKey(prevKey => prevKey + 1);
    //     }
    // }

    function handleDataChange(data) {
        setData(data);
        saveToLocalStorage("data", data);
    }

    function handleNoOfChildrenChange(noOfChildren) {
        setNoOfChildren(noOfChildren);
        saveToLocalStorage("no_of_children", noOfChildren);

        if(userType["user_type"] === UserType.FAMILY) {
            let len = 0;

            if(noOfChildren["no_of_children"] === NoOfChildren.ONE) {
                len = 1;
            }
            else if(noOfChildren["no_of_children"] === NoOfChildren.UP_TO_TWO) {
                len = 2;
            }
            else if(noOfChildren["no_of_children"] === NoOfChildren.UNLIMITED) {
                len = 3;
            }

            handleAgeOfChildrenFamChange({"age_of_children_fam": Array(len).fill("")});
        }
    }

    function handleAgeOfChildrenChange(ageOfChildren) {
        setAgeOfChildren(ageOfChildren);
        saveToLocalStorage("age_of_children", ageOfChildren);
    }

    function handleAgeOfChildrenFamChange(ageOfChildrenFam) {
        setAgeOfChildrenFam(ageOfChildrenFam);
        saveToLocalStorage("age_of_children_fam", ageOfChildrenFam);
    }

    function handleTimeInfoChange(timeInfo) {
        setTimeInfo(timeInfo);
        saveToLocalStorage("time_info", timeInfo);
    }

    function handleStartInfoChange(startInfo) {
        setStartInfo(startInfo);
        saveToLocalStorage("start_info", startInfo);
    }

    function handleSkillsChange(skills) {
        setSkills(skills);
        saveToLocalStorage("skills", skills);
    }

    function handleLanguagesChange(languages) {
        setLanguages(languages);
        saveToLocalStorage("languages", languages);
    }

    function handleCommentChange(comment) {
        setComment(comment);
        saveToLocalStorage("comment", comment);
    }

    function handleMiscellaneousChange(miscellaneous) {
        setMiscellaneous(miscellaneous);
        saveToLocalStorage("miscellaneous", miscellaneous);
    }

    function handleGenderNannyChange(gender) {
        setGenderNanny(gender);
        saveToLocalStorage("gender_nanny", gender);
    }

    function handleLeaveClick(e) {
        deleteAllFromLocalStorage();
        overlay.setOverlay(false);
        navigate("/");
    }


    // EXECUTE:

    if(location.pathname.endsWith("how_it_works/")){
        backwardsVisible = false;
    }
    else if(location.pathname.endsWith("start_now/")){
        if(validateAll()) {
            forwardsText = locale.msgs.FINALIZE;
        }
        else {
            forwardsVisible = false;
        }
    }
    else if(location.pathname.endsWith("data/")){
        forwardsClickable = validateData();
    }
    else if(location.pathname.endsWith("no_of_children/")){
        forwardsClickable = validateNoOfChildren();
    }
    else if(location.pathname.endsWith("age_of_children/")){
        forwardsClickable = validateAgeOfChildren();
    }
    else if(location.pathname.endsWith("age_of_children_fam/")){
        forwardsClickable = validateAgeOfChildrenFam();
    }
    else if(location.pathname.endsWith("time_info/")){
        forwardsClickable = validateTimeInfo();
    }
    else if(location.pathname.endsWith("start_info/")){
        forwardsClickable = validateStartInfo();
    }
    else if(location.pathname.endsWith("gender_nanny/")){
        forwardsClickable = validateGenderNanny();
    }
    else if(location.pathname.endsWith("miscellaneous/")){
        forwardsClickable = validateMiscellaneous();
    }
    else if(location.pathname.endsWith("done/")){
        forwardsText = locale.msgs.LOGOUT;
        backwardsVisible = false;
    }
    else if(location.pathname.endsWith("collect_data_error/")){
        forwardsText = locale.msgs.LOGOUT;
    }
    else if(location.pathname.endsWith("skills/")){
        forwardsClickable = validateSkills();
    }
    else if(location.pathname.endsWith("languages/")){
        forwardsClickable = validateLanguages();
    }
    else if(location.pathname.endsWith("comment/")){
        forwardsClickable = validateWishes();
    }


    // HOOKS:

    useLayoutEffect(() => {
        function perform() {
            if(!collectDataBoxRef.current) {
                return;
            }

            setCollectDataNavWidth(collectDataBoxRef.current.clientWidth);

            if(dataNavRef.current && window.innerWidth < 450) {
                setEndDummyHeight(dataNavRef.current.clientHeight);
            }
            else {
                setEndDummyHeight(0);
            }
        }

        perform();

        window.addEventListener("resize", perform);
        return () => window.removeEventListener("resize", perform);
    }, []);

    useEffect(() => {
        if(login.twoFactorAuthMobileNo) {
            setData({...data, "phone_number": login.twoFactorAuthMobileNo});
        }

    }, [login.twoFactorAuthMobileNo]);


    // RENDER:

    const nanny = userType["user_type"] == UserType.NANNY;

    return (
        <div ref={collectDataBoxRef} id="collect_data_box">
            <div id="collect_data_content" ref={scrollRef}>
                <div id="collect_data_content_scroll_dummy" ref={scrollDummyRef}></div>

                <ClosePopup fixed={true} helpDisplayed={closePopupDisaplyed}
                        onClose={() => setClosePopupDisaplyed(false) }
                        content={
                            <div className="popup_box_content">
                                <div className="head profile_head">{locale.msgs.ARE_YOU_SURE}</div>
                                <div dangerouslySetInnerHTML={{__html: locale.msgs.LEAVE_DATA_COLLECTION_DESCR}}
                                        className="text_2 margin_top_low_low"></div>

                                <div className="btn_right">
                                    <SquareButton text={locale.msgs.DELETE} clickable={true} onClick={ handleLeaveClick }/>
                                </div>
                            </div>
                        }
                />

                <HeaderWithButton closeBtn={true} onClick={handleOnCloseButtonClick} onHeaderClick={handleOnCloseButtonClick}
                        langSelection={true} />
                
                <div className="margin_to_header"></div>

                { (location.pathname.endsWith("done/") && consumer.mediationStatus !== MediationStatus.DATA_COLLECTED) ||
                        (!location.pathname.endsWith("done/") && consumer.mediationStatus !== MediationStatus.NONE) ?
                    <NavigateSmart to="/be_patient/" />
                :
                    <div id="collect_data_content_padded">
                        { !location.pathname.endsWith("done/") ?
                            <LeavePrompt />
                        :
                            null
                        }

                        <Routes>
                            <Route exact path="how_it_works/" element={<HowItWorks/>}></Route>

                            <Route path="*" element={
                                    <Routes>
                                        <Route exact path="start_now/" element={<StartNow dataDone={validateData()} wishesDone={validateWishes()}
                                            miscDone={validateMiscellaneous()} nanny={nanny}/>}>    
                                        </Route>

                                        <Route exact path="data/" element={<Data data={data}
                                                onDataChange={(data) => handleDataChange(data)}
                                                onScroll={(top, bottom) => handleScroll(top, bottom)}
                                                nanny={nanny}/>}></Route>

                                        <Route exact path="no_of_children/" element={<NoOfChildrenComp noOfChildren={noOfChildren}
                                                onNoOfChildrenChange={(noOfChildren) => handleNoOfChildrenChange(noOfChildren)}
                                                nanny={nanny} />}></Route>

                                        <Route exact path="age_of_children/" element={<AgeOfChildrenComp ageOfChildren={ageOfChildren}
                                                onAgeOfChildrenChange={(ageOfChildren) => handleAgeOfChildrenChange(ageOfChildren)}
                                                nanny={nanny} />}></Route>

                                        <Route exact path="age_of_children_fam/" element={<AgeOfChildrenFamComp ageOfChildrenFam={ageOfChildrenFam}
                                                onAgeOfChildrenFamChange={(ageOfChildrenFam) => handleAgeOfChildrenFamChange(ageOfChildrenFam)}
                                                noOfChildren={noOfChildren}
                                                nanny={nanny}/>}></Route>

                                        <Route exact path="time_info/" element={<TimeInfo timeInfo={timeInfo}
                                                onTimeInfoChange={(timeInfo) => handleTimeInfoChange(timeInfo)}
                                                nanny={nanny}/>}></Route>

                                        <Route exact path="start_info/" element={<StartInfo startInfo={startInfo}
                                                onStartInfoChange={(startInfo) => handleStartInfoChange(startInfo)}
                                                nanny={nanny}/>}></Route>

                                        <Route exact path="skills/" element={<Skills skills={skills}
                                                onSkillsChange={(skills) => handleSkillsChange(skills)}
                                                onSpecialCareTextError={setSpecialCareTextError}
                                                nanny={nanny}/>}></Route>

                                        <Route exact path="languages/" element={<Languages languages={languages}
                                                onLanguagesChange={(languages) => handleLanguagesChange(languages)}
                                                nanny={nanny} />}></Route>

                                        <Route exact path="comment/" element={<Comment comment={comment}
                                                onCommentChange={(comment) => handleCommentChange(comment)}
                                                onCommentError={setCommentError}
                                                nanny={nanny} />}></Route>

                                        <Route exact path="miscellaneous/" element={<Miscellaneous miscellaneous={miscellaneous}
                                                onMiscellaneousChange={(miscellaneous) => handleMiscellaneousChange(miscellaneous)}
                                                onOverlayChange={(o) => overlay.setOverlay(o)} onScroll={(top, bottom) => handleScroll(top, bottom)}
                                                nanny={nanny} />}></Route>

                                        <Route exact path="done/" element={<Done />}></Route>
                                        <Route exact path="collect_data_error/" element={<CollectDataError />}></Route>

                                        <Route exact path="gender_nanny/" element={<GenderNannyComp genderNanny={genderNanny}
                                                onGenderNannyChange={(gender) => handleGenderNannyChange(gender)}
                                                nanny={nanny} />}></Route>
                                    </Routes>
                                }
                            />

                        </Routes>
                    </div>
                }

                <div style={{width: "100%", height: endDummyHeight}}></div>
            </div>

            { consumer.declined ? null :
                <div ref={dataNavRef} id="forwards_backwards_bar_wrap_box" className="forwards_backwards_bar_wrap_box" style={{width: collectDataNavWidth}}>
                    <ForwardsBackwardsBar backwardsVisible={backwardsVisible} forwardsVisible={forwardsVisible}
                            backwardsClickable={backwardsClickable} forwardsClickable={forwardsClickable}
                            onBackwards={handleBackwards} onForwards={handleForwards}
                            backwardsText={locale.msgs.BACK} forwardsText={forwardsText}
                            forwardsLoadState={loadState} />
                </div>
            }

        </div>
    );
}

/*
window.Clipboard = (function(window, document, navigator) {
    var textArea,
        copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        // textArea.style.display = "none";
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range,
            selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        } else {
            textArea.select();
        }
    }

    function copyToClipboard() {        
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }

    copy = function(text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
    };

    return {
        copy: copy
    };
})(window, document, navigator);
*/

export function HowItWorks(props) {
    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);

    return (
        <div id="how_it_works">
            <div className="head">{locale.msgs.HOW_IT_WORKS}</div>
            <div className="text">
                <span dangerouslySetInnerHTML={{__html: locale.msgs.HOW_IT_WORKS_DESCR}}></span>
                <LinkSmart className="link" to={"/how_it_works/"} target="_blank">{locale.msgs.HOW_IT_WORKS}.</LinkSmart>
                {locale.msgs.HOW_IT_WORKS_DESCR_2}
            </div>
        </div>
    );
}

export function StartNow(props) {
    const locale = useContext(LocaleContext);

    const navigate = useNavigateSmart();

    function handleClickData(e){
        navigate("/collect_data/data/");
    }

    function handleClickWishes(e){
        navigate("/collect_data/no_of_children/");
    }

    function handleClickMisc(e){
        navigate("/collect_data/miscellaneous/");
    }

    let count = 0;

    if(props.dataDone) {
        count++;
    }
    if(props.wishesDone) {
        count++;
    }
    if(props.miscDone) {
        count++;
    }

    let head = "";
    let descr = "";

    if(count == 0) {
        head = locale.msgs.START_DATA_COLLECTION;
        descr = props.nanny ? locale.msgs.START_DATA_COLLECTION_DESCR_NANNY : locale.msgs.START_DATA_COLLECTION_DESCR_FAMILY;
    }
    else if(count == 1) {
        head = locale.msgs.START_DATA_COLLECTION_2;
        descr = props.nanny ? locale.msgs.START_DATA_COLLECTION_2_DESCR_NANNY : locale.msgs.START_DATA_COLLECTION_2_DESCR_FAMILY;
    }
    else if(count == 2) {
        head = locale.msgs.START_DATA_COLLECTION_3;
        descr = locale.msgs.START_DATA_COLLECTION_3_DESCR;
    }
    else if(count == 3) {
        head = locale.msgs.START_DATA_COLLECTION_DONE;
        descr = locale.msgs.START_DATA_COLLECTION_DONE_DESCR;
    }

    return(
        <div id="start_now">
            <div className="head">{head}</div>
            <div className="text" dangerouslySetInnerHTML={{__html: descr}}></div>

            <div id="bar_one" className="bar">
                <BarButton text={locale.msgs.DATA} done={props.dataDone} onClick={() => handleClickData()}/>
            </div>
            
            <div id="bar_two" className="bar">
                <BarButton text={props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY} done={props.wishesDone} onClick={() => handleClickWishes()} />
            </div>

            <div id="bar_three" className="bar">
                <BarButton text={locale.msgs.MISCELLANEOUS} done={props.miscDone} onClick={() => handleClickMisc()} />
            </div>

            <div className="text_small_small_3 start_now_privacy_policy">
                <span dangerouslySetInnerHTML={{__html: locale.msgs.PRIVACY_POLICY_COLLECT_DATA_DESCR}}></span>
                <LinkSmart className="link_2" to={"/privacy_policy/"} target="_blank">{locale.msgs.PRIVACY_POLICY}</LinkSmart>
            </div>

            
        </div>
    );
}

export function Data(props) {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);

    const [manualErrorTextDisplayInfoObj, setManualErrorTextDisplayInfoObj] = useState(-1);

    const dataRef = useRef(null);


    // FUNCTIONS:

    function get_most_recent_input_idx() {
        let idx = -1;

        if(dataRef.current["salutation"] && dataRef.current["salutation"] !== Salutation.NONE) {
            idx = 0;
        }
        if(dataRef.current["title"] && dataRef.current["title"] !== Title.NONE) {
            idx = 1;
        }
        if(dataRef.current["first_name"] && dataRef.current["first_name"] !== Title.NONE) {
            idx = 2;
        }
        if(dataRef.current["last_name"] && dataRef.current["last_name"] !== Title.NONE) {
            idx = 3;
        }
        if(dataRef.current["birth_date"] && dataRef.current["birth_date"] !== "") {
            idx = 4;
        }
        if(dataRef.current["gender"] && dataRef.current["gender"] !== Gender.NONE) {
            idx = 5;
        }
        if(dataRef.current["email"] && dataRef.current["email"] !== "") {
            idx = 6;
        }
        if(dataRef.current["phone_number"] && dataRef.current["phone_number"] !== "") {
            if(!login.twoFactorAuthMobileNo) {
                idx = 7;
            }
        }
        if(dataRef.current["graduation"] && dataRef.current["graduation"] !== Graduation.NONE) {
            idx = 8;
        }
        if(dataRef.current["current_employment"] && dataRef.current["current_employment"] !== "") {
            idx = 9;
        }
        if(dataRef.current["street_and_house_no"] && dataRef.current["street_and_house_no"] !== "") {
            idx = 10;
        }
        if(dataRef.current["post_code"] && dataRef.current["post_code"] !== "") {
            idx = 11;
        }
        if(dataRef.current["city"] && dataRef.current["city"] !== "") {
            idx = 12;
        }

        return idx;
    }

    function handleBlur() {
        const most_recent_input_idx = get_most_recent_input_idx();

        // console.log(most_recent_input_idx);
        const obj = {};

        obj["salutation"] = (!dataRef.current["salutation"] || dataRef.current["salutation"] === Salutation.NONE) && most_recent_input_idx > 1;
        obj["first_name"] = (!dataRef.current["first_name"] || dataRef.current["first_name"] === "") && most_recent_input_idx > 3;
        obj["last_name"] = (!dataRef.current["last_name"] || dataRef.current["last_name"] === "") && most_recent_input_idx > 4;
        obj["birth_date"] = (!dataRef.current["birth_date"] || dataRef.current["birth_date"] === "") && most_recent_input_idx > 5;
        obj["gender"] = (!dataRef.current["gender"] || dataRef.current["gender"] === "") && most_recent_input_idx > 6;
        obj["phone_number"] = (!dataRef.current["phone_number"] || dataRef.current["phone_number"] === "") && most_recent_input_idx > 8;
        obj["graduation"] = (!dataRef.current["graduation"] || dataRef.current["graduation"] === Graduation.NONE) && most_recent_input_idx > 9;
        obj["current_employment"] = (!dataRef.current["current_employment"] || dataRef.current["current_employment"] === "") && most_recent_input_idx > 10;
        obj["street_and_house_no"] = (!dataRef.current["street_and_house_no"] || dataRef.current["street_and_house_no"] === "") && most_recent_input_idx > 11;
        obj["post_code"] = (!dataRef.current["post_code"] || dataRef.current["post_code"] === "") && most_recent_input_idx > 12;
        obj["city"] = (!dataRef.current["city"] || dataRef.current["city"] === "") && most_recent_input_idx > 13;

        setManualErrorTextDisplayInfoObj(obj);
    }

    function handleDataChange(data) {
        dataRef.current = data;
        props.onDataChange(data);
    }


    // EFFECTS:

    useLayoutEffect(() => {
        handleBlur();
    }, []);


    // RENDER:

    const [genderTransList, genderTransListInverse] = get_translation_objects("gender", Gender, locale);
    const [salutationTransList, salutationTransListInverse] = get_translation_objects("salutation", Salutation, locale);
    const [titleTransList, titleTransListInverse] = get_translation_objects("title", Title, locale);
    const [graduationTransList, graduationTransListInverse] = get_translation_objects("graduation", Graduation, locale);

    return (
        <div id="data">
            <ProgressBar pct="100%"/>
            <div className="head head_bar">{locale.msgs.DATA}</div>

            <div className="data_box data_box_hori">
                <div className="data_box_hori_box data_box_hori_box_gap">
                    <DropdownMenuWithManualError text={locale.msgs.SALUTATION} options={Object.values(salutationTransList)}
                            value={salutationTransList[props.data["salutation"]]}
                            onValueChange={(value) => handleDataChange({...props.data, "salutation": salutationTransListInverse[value]})}
                            onScroll={props.onScroll}
                            manualErrorText={manualErrorTextDisplayInfoObj["salutation"] ? locale.msgs.PLEASE_FILL : null}
                            onBlur={handleBlur} />
                </div>
                
                <div className="data_box_hori_box">
                    <DropdownMenuWithManualError text={locale.msgs.TITLE} options={Object.values(titleTransList)}
                            optional={true} noText="-"
                            value={titleTransList[props.data["title"]]}
                            onValueChange={(value) => handleDataChange({...props.data, "title": titleTransListInverse[value]})}
                            onScroll={props.onScroll}
                            manualErrorText={false}
                            onBlur={handleBlur} />
                </div>
            </div>

            <div className="data_box" id="data_box_3">
                <TextInput text={locale.msgs.FIRST_NAME} value={props.data["first_name"]}
                        onChange={(value) => {
                            handleDataChange({...props.data, "first_name": value});
                        }}
                        manualErrorText={manualErrorTextDisplayInfoObj["first_name"] ? locale.msgs.PLEASE_FILL : null}
                        onBlur={handleBlur}
                        autocomplete="given-name"
                        name="given-name"
                        errorText={locale.msgs.PLEASE_ENTER_VALID_NAME}
                        checker={(value) => validateName(value)}
                        maxLength={maxNameLength} />
            </div>

            <div className="data_box" id="data_box_3">
                <TextInput text={locale.msgs.LAST_NAME} value={props.data["last_name"]}
                        onChange={(value) => handleDataChange({...props.data, "last_name": value})}
                        manualErrorText={manualErrorTextDisplayInfoObj["last_name"] ? locale.msgs.PLEASE_FILL : null}
                        onBlur={handleBlur}
                        autocomplete="family-name"
                        name="family-name"
                        errorText={locale.msgs.PLEASE_ENTER_VALID_NAME}
                        checker={(value) => validateName(value)}
                        maxLength={maxNameLength} />
            </div>

            { props.nanny ?
                <div className="data_box data_box_hori">
                    <div className="data_box_hori_box data_box_hori_box_gap">
                        <DateInput text={locale.msgs.BIRTHDAY} value={props.data["birth_date"]}
                                onChange={(value) => {
                                    handleDataChange({...props.data, "birth_date": value});
                                    
                                    // To also update the manualErrorState of this input if the picker selects a date and
                                    // onBlur is not fired
                                    if(value) {
                                        handleBlur();
                                    }
                                }}
                                legalAge={true}
                                onScroll={props.onScroll}
                                manualErrorText={manualErrorTextDisplayInfoObj["birth_date"] ? locale.msgs.PLEASE_FILL : null}
                                onBlur={handleBlur}
                                autocomplete="bday"
                                name="bday"
                                pickerRecreateState={props.data} />
                    </div>
                    
                    <div className="data_box_hori_box">
                        <DropdownMenuWithManualError text={locale.msgs.GENDER} options={Object.values(genderTransList)}
                                value={genderTransList[props.data["gender"]]}
                                onValueChange={(value) => handleDataChange({...props.data, "gender": genderTransListInverse[value]})}
                                onScroll={props.onScroll}
                                manualErrorText={manualErrorTextDisplayInfoObj["gender"] ? locale.msgs.PLEASE_FILL : null}
                                onBlur={handleBlur} />
                    </div>
                </div>
                : null
            }

            <div className="data_box" id="data_box_3">
                <TextInput text={locale.msgs.EMAIL_ADDRESS} value={login.username} readOnly={true}
                        onChange={(value) => {}}
                        checker={(v) => checkEmail(v)}
                        type="email" errorText={locale.msgs.ENTER_VALID_EMAIL_ADDRESS}
                        maxLength={maxUsernameLength}
                        manualErrorText={false}
                        onBlur={handleBlur}
                        autocomplete="email"
                        name="email" />
            </div>

            <div className="data_box" id="data_box_3">
                <TelNoInputNew value={props.data["phone_number"]}
                        onChange={(value) => handleDataChange({...props.data, "phone_number": value})}
                        readOnly={login.twoFactorAuthType === TwoFactorAuthType.MOBILE}
                />
            </div>

            { props.nanny ?
                <div>
                    <div className="data_box" id="data_box_1">
                        <DropdownMenuWithManualError text={locale.msgs.GRADUATION} options={Object.values(graduationTransList)}
                                value={graduationTransList[props.data["graduation"]]}
                                onValueChange={(value) => handleDataChange({...props.data, "graduation": graduationTransListInverse[value]})}
                                onScroll={props.onScroll}
                                manualErrorText={manualErrorTextDisplayInfoObj["graduation"] ? locale.msgs.PLEASE_FILL : null}
                                onBlur={handleBlur} />
                    </div>

                    <div className="data_box" id="data_box_3">
                        <TextInput text={locale.msgs.CURRENT_EMPLOYMENT} value={props.data["current_employment"]}
                                onChange={(value) => {
                                    handleDataChange({...props.data, "current_employment": value});
                                }}
                                manualErrorText={manualErrorTextDisplayInfoObj["current_employment"] ? locale.msgs.PLEASE_FILL : null}
                                onBlur={handleBlur}
                                autocomplete="?????????????????????"
                                name="?????????????????????"
                                errorText={locale.msgs.INVALID_VALUE}
                                checker={(value) => validateCurrentEmployment(value)}
                                maxLength={maxCurrentEmploymentLength} />
                    </div>
                </div>
                : null
            }

            { true ?
                <div className="data_box" id="data_box_3">
                    <TextInput text={locale.msgs.STREET_AND_HOUSE_NO} value={props.data["street_and_house_no"]}
                            onChange={(value) => {
                                handleDataChange({...props.data, "street_and_house_no": value});
                            }}
                            manualErrorText={manualErrorTextDisplayInfoObj["street_and_house_no"] ? locale.msgs.PLEASE_FILL : null}
                            onBlur={handleBlur}
                            autocomplete="street-address"
                            name="street-address"
                            errorText={locale.msgs.PLEASE_ENTER_VALID_STREET_AND_HOUSE_NO}
                            checker={(value) => validateStreetAndHouseNo(value)}
                            maxLength={maxStreetAndHouseNoLength} />
                </div>
                : null
            }

            <div className="data_box" id="data_box_3">
                <TextInput text={locale.msgs.POST_CODE} value={props.data["post_code"]}
                        onChange={(value) => handleDataChange({...props.data, "post_code": value})}
                        manualErrorText={manualErrorTextDisplayInfoObj["post_code"] ? locale.msgs.PLEASE_FILL : null}
                        onBlur={handleBlur}
                        autocomplete="postal-code"
                        name="postal-code"
                        errorText={locale.msgs.PLEASE_ENTER_VALID_POST_CODE}
                        checker={(value) => validatePostCode(value)}
                        maxLength={maxPostCodeLength} />
            </div>

            <div className="data_box" id="data_box_3">
                <TextInput text={locale.msgs.CITY} value={props.data["city"]}
                        onChange={(value) => handleDataChange({...props.data, "city": value})}
                        manualErrorText={manualErrorTextDisplayInfoObj["city"] ? locale.msgs.PLEASE_FILL : null}
                        onBlur={handleBlur}
                        autocomplete="address-level2"
                        name="city"
                        errorText={locale.msgs.PLEASE_ENTER_VALID_CITY}
                        checker={(value) => validateCity(value)}
                        maxLength={maxCityLength} />
            </div>

        </div>
    );
}

export function NoOfChildrenComp(props) {
    const locale = useContext(LocaleContext);

    let initArr = Array(3).fill(false);

    if(props.noOfChildren["no_of_children"] == NoOfChildren.UNLIMITED){
        initArr[0] = true;
    }
    else if(props.noOfChildren["no_of_children"] == NoOfChildren.UP_TO_TWO) {
        initArr[1] = true;
    }
    else if(props.noOfChildren["no_of_children"] == NoOfChildren.ONE) {
        initArr[2] = true;
    }

    let [radioBtnCheckedState, setRadioBtnCheckedState] = useState(initArr);

    function handleRadioBtnChange(e) {
        let id = e.target.id.split("_")[1];
        let newBtnCheckedState = Array(3).fill(false);
        newBtnCheckedState[id] = true;
        setRadioBtnCheckedState(newBtnCheckedState);

        props.onNoOfChildrenChange({"no_of_children": e.target.name});
    }

    return(
        <div id="no_of_children">
            <ProgressBar pct={props.nanny ? "13%" : "11%"}/>

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.HOW_MANY_CHILDREN_CARE_MN : locale.msgs.HOW_MANY_CHILDREN_CARE_FAM}</div>

            {/* <div className="text_big">{locale.msgs.NO_OF_CHILDREN}</div> */}

            <div className="collect_data_ele_after_descr">
                <RadioCheckButton type="radio" text={props.nanny ? locale.msgs.NO_OF_CHILDREN_MN_UNLIMITED : locale.msgs.NO_OF_CHILDREN_FAM_UNLIMITED} id="noc_0" name={NoOfChildren.UNLIMITED.toString()} checked={radioBtnCheckedState[0]}
                    onChange={(e) => handleRadioBtnChange(e)}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" text={props.nanny ? locale.msgs.NO_OF_CHILDREN_MN_UP_TO_TWO : locale.msgs.NO_OF_CHILDREN_FAM_UP_TO_TWO} id="noc_1" name={NoOfChildren.UP_TO_TWO.toString()} checked={radioBtnCheckedState[1]}
                    onChange={(e) => handleRadioBtnChange(e)}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" text={props.nanny ? locale.msgs.NO_OF_CHILDREN_MN_ONE : locale.msgs.NO_OF_CHILDREN_FAM_ONE} id="noc_2" name={NoOfChildren.ONE.toString()} checked={radioBtnCheckedState[2]}
                    onChange={(e) => handleRadioBtnChange(e)}/>
            </div>
        </div>
    )
}

export function AgeOfChildrenComp(props) {
    const locale = useContext(LocaleContext);

    let specific = (
        <div className="specific_box">
            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.ONE_TO_TWO_YEARS} id="0" name="age_specific" checked={props.ageOfChildren["age_of_children_specific_1-2"]}
                        onChange={(e) => props.onAgeOfChildrenChange({...props.ageOfChildren, "age_of_children_specific_1-2": e.target.checked})}/>
            </div>
            
            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.THREE_TO_SIX_YEARS} id="1" name="age_specific" checked={props.ageOfChildren["age_of_children_specific_3-6"]}
                        onChange={(e) => props.onAgeOfChildrenChange({...props.ageOfChildren, "age_of_children_specific_3-6": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.MORE_THAN_SEVEN_YEARS} id="2" name="age_specific" checked={props.ageOfChildren["age_of_children_specific_>6"]}
                        onChange={(e) => props.onAgeOfChildrenChange({...props.ageOfChildren, "age_of_children_specific_>6": e.target.checked})}/>
            </div>
        </div>
    );

    return (
        <div className="age_of_children">
            <ProgressBar pct="25%"/>

            <div className="head head_bar">{locale.msgs.WISHES_NANNY}</div>
            <div className="text collect_data_descr">{locale.msgs.HOW_OLD_CHILDREN_MN}</div>

            {/* <div className="text_big" id="age_label">{locale.msgs.AGE_OF_CHILDREN}</div> */}

            <div className="collect_data_ele_after_descr">
                <RadioCheckButton type="radio" id="age_0" name="age" text={locale.msgs.NO_MATTER}
                        checked={props.ageOfChildren["age_of_children"] == AgeOfChildren.NO_MATTER} 
                        onChange={(e) => props.onAgeOfChildrenChange({...props.ageOfChildren, "age_of_children": AgeOfChildren.NO_MATTER})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="age_1" name="age" text={locale.msgs.AGE_OF_CHILDREN_SPECIFIC}
                        checked={props.ageOfChildren["age_of_children"] == AgeOfChildren.SPECIFIC}
                        onChange={(e) => props.onAgeOfChildrenChange({...props.ageOfChildren, "age_of_children": AgeOfChildren.SPECIFIC})}/>
            </div>

            {props.ageOfChildren["age_of_children"] == AgeOfChildren.SPECIFIC ? specific : null}

        </div>
    );
}

export function AgeOfChildrenFamComp(props) {
    const locale = useContext(LocaleContext);

    return (
        <div className="age_of_children_fam">
            <ProgressBar pct="22%"/>

            <div className="head head_bar">{locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{locale.msgs.HOW_OLD_CHILDREN_FAM}</div>

            {/* <div className="text_big margin_bottom_low_low" id="age_label">{locale.msgs.AGE_OF_CHILDREN}</div> */}

            <div className="collect_data_ele_after_descr">
                <AgeOfChildrenFamSelect editable={true} ageOfChildrenFam={props.ageOfChildrenFam["age_of_children_fam"]}
                        onAgeOfChildrenFamChange={(v) => props.onAgeOfChildrenFamChange({...props.ageOfChildrenFam, "age_of_children_fam" : v})} />
            </div>
        </div>
    );
}

export function TimeInfo(props) {
    const locale = useContext(LocaleContext);

    let specific = (
        <div className="specific_box">
            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.MONADAY} id="0" name="age_specific"
                        checked={props.timeInfo["week_days_specific_monday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_monday": e.target.checked})}/>
            </div>
            
            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.TUESDAY} id="1" name="age_specific"
                        checked={props.timeInfo["week_days_specific_tuesday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_tuesday": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.WEDNESDAY} id="2" name="age_specific"
                        checked={props.timeInfo["week_days_specific_wednesday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_wednesday": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.THURSDAY} id="3" name="age_specific"
                        checked={props.timeInfo["week_days_specific_thursday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_thursday": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.FRIDAY} id="4" name="age_specific"
                        checked={props.timeInfo["week_days_specific_friday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_friday": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.SATURDAY} id="5" name="age_specific"
                        checked={props.timeInfo["week_days_specific_saturday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_saturday": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" text={locale.msgs.SUNDAY} id="6" name="age_specific"
                        checked={props.timeInfo["week_days_specific_sunday"]}
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days_specific_sunday": e.target.checked})}/>
            </div>
        </div>
    );

    return (
        <div className="time">
            <ProgressBar pct={props.nanny ? "37%" : "33%"}/>

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.HOW_MUCH_TIME_CHILDCARE_NANNY : locale.msgs.HOW_MUCH_TIME_CHILDCARE_FAMILY }</div>


            <div className="text_big" id="age_label">{props.nanny ? locale.msgs.AVAILABILITY : locale.msgs.NEED}</div>

            <div className="radio" id="time_radio_1">
                <RadioCheckButton type="radio" id="time_during_day_radio_0" name="time_during_day" text={locale.msgs.AVAILABILITY_HOURLYWISE}
                        checked={props.timeInfo["availability_time"] == AvailabilityTime.HOURLYWISE} 
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "availability_time": AvailabilityTime.HOURLYWISE})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="time_during_day_radio_1" name="time_during_day" text={locale.msgs.AVAILABILITY_HALF_DAY}
                        checked={props.timeInfo["availability_time"] == AvailabilityTime.HALF_DAY} 
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "availability_time": AvailabilityTime.HALF_DAY})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="time_during_day_radio_2" name="time_during_day" text={locale.msgs.AVAILABILITY_FULL_DAY}
                        checked={props.timeInfo["availability_time"] == AvailabilityTime.FULL_DAY} 
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "availability_time": AvailabilityTime.FULL_DAY})}/>
            </div>


            <div className="text_big" id="age_label">{locale.msgs.WEEK_DAYS}</div>

            <div className="radio" id="time_radio_4">
                <RadioCheckButton type="radio" id="week_day_0" name="week_day" text={locale.msgs.WEEK_DAYS_FLEXIBLE}
                        checked={props.timeInfo["week_days"] == WeekDays.FLEXIBLE} 
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days": WeekDays.FLEXIBLE})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="week_day_1" name="week_day" text={locale.msgs.WEEK_DAYS_SPECIFIC}
                        checked={props.timeInfo["week_days"] == WeekDays.SPECIFIC} 
                        onChange={(e) => props.onTimeInfoChange({...props.timeInfo, "week_days": WeekDays.SPECIFIC})}/>
            </div>

            {props.timeInfo["week_days"] == WeekDays.SPECIFIC ? specific : null}


            <ForwardsBackwardsBar backwardsClickable={true} forwardsClickable={true} onBackwards={props.onBackwards} onForwards={props.onForwards}/>
        </div>
    );
}

export function StartInfo(props) {
    const locale = useContext(LocaleContext);

    let specific = (
        <div className="specific_box">
            <div className="radio">
                <DateInput text={locale.msgs.DATE} value={props.startInfo["start_specific"]}
                        onChange={(date) => {props.onStartInfoChange({...props.startInfo, "start_specific": date})}}
                        showPlaceholderIfNotEmpty={false}
                        mustBeInFuture={true}
                        maxDaysInFuture={365}
                        pickerRecreateState={props.startInfo} />
            </div>
        </div>
    );

    return (
        <div className="start">
            <ProgressBar pct={props.nanny ? "50%" : "44%"}/>

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.WHEN_START_CARE_NANNY : locale.msgs.WHEN_START_CARE_FAMILY}</div>

            {/* <div className="text_big">{locale.msgs.START_BROKERAGE}</div> */}

            <div className="collect_data_ele_after_descr" id="start_radio_1">
                <RadioCheckButton type="radio" id="start_0" name="start" text={locale.msgs.START_BROKERAGE_ASAP} checked={props.startInfo["start"] == Start.ASAP} 
                    onChange={(e) => props.onStartInfoChange({...props.startInfo, "start": Start.ASAP, "start_specific": ""})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="start_1" name="start" text={locale.msgs.START_BROKERAGE_SPECIFIC} checked={props.startInfo["start"] == Start.SPECIFIC}
                    onChange={(e) => props.onStartInfoChange({...props.startInfo, "start": Start.SPECIFIC})}/>
            </div>

            {props.startInfo["start"] == Start.SPECIFIC ? specific : null}

        </div>
    );
}

export function GenderNannyComp(props) {
    const locale = useContext(LocaleContext);

    return (
        <div id="gender_nanny">
            <ProgressBar pct="55%"/>

            <div className="head head_bar">{locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{locale.msgs.HAVE_PREFERENCES}</div>

            {/* <div className="text_big">{locale.msgs.GENDER_MN}</div> */}

            <div className="collect_data_ele_after_descr" id="start_radio_1">
                <RadioCheckButton type="radio" id="gender_0" name="gender" text={locale.msgs.NO_MATTER} checked={props.genderNanny["gender_nanny"] == GenderNanny.NO_MATTER} 
                    onChange={(e) => props.onGenderNannyChange({...props.genderNanny, "gender_nanny": GenderNanny.NO_MATTER})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="gender_1" name="gender" text={locale.msgs.MALE} checked={props.genderNanny["gender_nanny"] == GenderNanny.MALE}
                    onChange={(e) => props.onGenderNannyChange({...props.genderNanny, "gender_nanny": GenderNanny.MALE})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="gender_2" name="gender" text={locale.msgs.FEMALE} checked={props.genderNanny["gender_nanny"] == GenderNanny.FEMALE}
                    onChange={(e) => props.onGenderNannyChange({...props.genderNanny, "gender_nanny": GenderNanny.FEMALE})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="radio" id="gender_3" name="gender" text={locale.msgs.DIVERSE} checked={props.genderNanny["gender_nanny"] == GenderNanny.DIVERSE}
                    onChange={(e) => props.onGenderNannyChange({...props.genderNanny, "gender_nanny": GenderNanny.DIVERSE})}/>
            </div>

        </div>
    );
}

export function Skills(props) {
    const locale = useContext(LocaleContext);

    return (
        <div className="skills">
            <ProgressBar pct={props.nanny ? "62%" : "67%"}/>

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.WHAT_SKILLS_DO_YOU_HAVE : locale.msgs.WHAT_SKILLS_DO_YOU_WISH}</div>

            {/* <div className="text_big">{props.nanny ? locale.msgs.YOUR_SKILLS : locale.msgs.DESIRED_SKILLS}</div> */}

            <div className="collect_data_ele_after_descr" id="skills_radio_1">
                <RadioCheckButton type="checkbox" id="skills_0" name="start" text={locale.msgs.DRIVERS_LICENSE} checked={props.skills["drivers_license"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "drivers_license": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_1" name="start" text={props.nanny ? locale.msgs.DRIVE_FOREIGN_CAR : locale.msgs.DRIVE_FAMILY_CAR} checked={props.skills["drive_foreign_car"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "drive_foreign_car": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_2" name="start" text={locale.msgs.HOMEWORK_SUPPORT} checked={props.skills["homework_support"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "homework_support": e.target.checked})}/>
            </div>

            { !props.nanny ?
                <div>
                    <div className="radio">
                        <RadioCheckButton type="checkbox" id="skills_22" name="start" text={locale.msgs.SPECIAL_CARE} checked={props.skills["special_care"]} 
                            onChange={(e) => props.onSkillsChange({...props.skills, "special_care": e.target.checked})}/>
                    </div>

                    { props.skills["special_care"] ?
                        <div className="specific_box">
                            <div className="radio">
                                <TextInputMultiline text={locale.msgs.SPECIAL_CARE} value={props.skills["special_care_text"]}
                                        onChange={(value) => props.onSkillsChange({...props.skills, "special_care_text": value})}
                                        onError={props.onSpecialCareTextError}
                                        showPlaceholderIfNotEmpty={false} height="10rem"
                                        maxLength={maxSpecialCareTextLength} />
                            </div>
                        </div>
                    : null
                    }

                </div>
                
            : null
            }

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_3" name="start" text={locale.msgs.FIRST_AID_CURSE_FOR_CHILDREN} checked={props.skills["first_aid_course_for_children"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "first_aid_course_for_children": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_4" name="start" text={props.nanny ? locale.msgs.PETS_ARE_OK : locale.msgs.NO_PROBLEMS_WITH_PETS}
                    checked={props.skills["pets_are_ok"]} onChange={(e) => props.onSkillsChange({...props.skills, "pets_are_ok": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_5" name="start" text={locale.msgs.MUSICALLY} checked={props.skills["musically"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "musically": e.target.checked})}/>
            </div>

            <div className="radio">
                <RadioCheckButton type="checkbox" id="skills_6" name="start" text={locale.msgs.COOKING} checked={props.skills["cooking"]} 
                    onChange={(e) => props.onSkillsChange({...props.skills, "cooking": e.target.checked})}/>
            </div>

        </div>
    );
}

export function Languages(props) {
    const locale = useContext(LocaleContext);

    return (
        <div className="languages">
            <ProgressBar pct={props.nanny ? "75%" : "78%"} />

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY }</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.WHAT_LANGUAGES_DO_YOU_SPEEK : locale.msgs.WHAT_LANGUAGES_DO_YOU_WANT}</div>

            {/* <div className="text_big">{props.nanny ? locale.msgs.YOUR_LANGUAGES : locale.msgs.DESIRED_LANGUAGES}</div> */}

            <div className="collect_data_language_select">
                <LanguagesSelect languages={props.languages["languages"]} onLanguagesChange={(langs) => props.onLanguagesChange({...props.languages, "languages": langs})}
                        maxLanguages={!props.nanny ? maxLanguagesFamily : maxLanguagesNanny } />
            </div>

        </div>
    );
}

export function Comment(props) {
    const locale = useContext(LocaleContext);

    return (
        <div className="comment">
            <ProgressBar pct={props.nanny ? "87%" : "89%"}/>

            <div className="head head_bar">{props.nanny ? locale.msgs.WISHES_NANNY : locale.msgs.WISHES_FAMILY}</div>
            <div className="text collect_data_descr">{props.nanny ? locale.msgs.COMMENT_DESCR_NANNY : locale.msgs.COMMENT_DESCR_FAMILY}</div>

            <div className="collect_data_ele_after_descr">
                <TextInputMultiline text={locale.msgs.COMMENT_LABEL} value={props.comment["comment"]}
                        onChange={(value) => props.onCommentChange({"comment": value})}
                        onError={props.onCommentError}
                        showPlaceholderIfNotEmpty={false}
                        height="10rem"
                        maxLength={maxCustomerCommentLength} />
            </div>

        </div>
    );
}

export function Miscellaneous(props) {
    const locale = useContext(LocaleContext);

    let [helpDisplayed, setHelpDisplayed] = useState(false);

    function handleHelp(e) {
        setHelpDisplayed(true);
    }

    let specific = (
        <div className="specific_box">
            <div className="radio">
                <TextInput text={locale.msgs.WEEK_DAYS_TIME} value={props.miscellaneous["specific_availability_by_phone"]}
                        onChange={(text) => {props.onMiscellaneousChange({...props.miscellaneous, "specific_availability_by_phone": text})}}
                        showPlaceholderIfNotEmpty={false}
                        checker={(value) => validateSpecificAvailabilityByPhone(value)}
                        errorText={locale.msgs.INVALID_VALUE}
                        maxLength={maxSpecificAvailabilityByPhoneLength} />
            </div>
        </div>
    );

    const [recTransList, recTransListInverse] = get_translation_objects("recommendation", Recommendation, locale);
    const [displayLangTransList, displayLangTransListInverse] = get_translation_objects("display_language", DisplayLanguage, locale);

    return (
        <div className="miscellaneous">
            <ProgressBar pct="100%"/>

            <div className="head head_bar" id="misc_head">
                <div id="misc_head_overlay">
                    <HelpBtn onClick={(e) => handleHelp(e)} />
                </div>

                {locale.msgs.MISCELLANEOUS}
            </div>

            <ClosePopup helpDisplayed={helpDisplayed} onClose={() => setHelpDisplayed(false)} content={
                <div className="help_content">
                    {/*<div className="text_big_3 margin_top_low_low">{locale.msgs.NOTIFICATIONS}</div>
                    <div className="text_light">{locale.msgs.AVAILABILITY_HELP}</div>*/}

                    <div className="text_big">{locale.msgs.TELEPHONE_AVAILABILITY_2}</div>
                    <div className="text_light">{locale.msgs.TELEPHONE_AVAILABILITY_HELP}</div>
                </div>
            } />

            {/* <div className="text">Wie möchtest du in Zukunft über Neuigkeiten informiert werden und wann können wir dich telefonisch erreichen?</div> */}

            {/*
            <div className="text_big">{locale.msgs.NOTIFICATIONS}</div>

            <div className="radio" id="notification_radio_1">
                <RadioCheckButton type="radio" text={locale.msgs.EMAIL} id="0" name="notification"
                        checked={props.miscellaneous["notifications"] == Notifications.E_MAIL}
                        onChange={(e) => e.target.checked ? props.onMiscellaneousChange({...props.miscellaneous, "notifications": Notifications.E_MAIL}) : null}/>
            </div>
            
            <div className="radio" id="notification_radio_2">
                <RadioCheckButton type="radio" text={locale.msgs.SMS} id="1" name="notification"
                        checked={props.miscellaneous["notifications"] == Notifications.SMS}
                        onChange={(e) => e.target.checked ? props.onMiscellaneousChange({...props.miscellaneous, "notifications": Notifications.SMS}) : null}/>
            </div>
            */}

            <div className="text_big">{locale.msgs.WHICH_LANGUAGE_FOR_EMAILS}</div>

            <div className="radio">
                <DropdownMenu text="Wählen" options={Object.values(displayLangTransList)}
                            value={displayLangTransList[props.miscellaneous["display_language"]]}
                            onValueChange={(value) => props.onMiscellaneousChange(
                                {...props.miscellaneous, "display_language": displayLangTransListInverse[value]})}
                            showPlaceholderIfNotEmpty={false}
                            onScroll={props.onScroll} />
            </div>

            <div className="text_big">{locale.msgs.TELEPHONE_AVAILABILITY}</div>

            <div className="radio" id="availability_by_phone_radio_1">
                <RadioCheckButton type="radio" text={locale.msgs.TELEPHONE_AVAILABILITY_ALWAYS} id="availability_by_phone_1" name="availability_by_phone"
                        checked={props.miscellaneous["availability_by_phone"] == AvailabilityByPhone.ALWAYS}
                        onChange={(e) => e.target.checked ? props.onMiscellaneousChange({...props.miscellaneous, "availability_by_phone": AvailabilityByPhone.ALWAYS}) : null}/>
            </div>
            
            <div className="radio" id="availability_by_phone_radio_2">
                <RadioCheckButton type="radio" text={locale.msgs.TELEPHONE_AVAILABILITY_SPECIFIC} id="availability_by_phone_2" name="availability_by_phone"
                        checked={props.miscellaneous["availability_by_phone"] == AvailabilityByPhone.SPECIFIC}
                        onChange={(e) => e.target.checked ? props.onMiscellaneousChange({...props.miscellaneous, "availability_by_phone": AvailabilityByPhone.SPECIFIC}) : null}/>
            </div>

            {props.miscellaneous["availability_by_phone"] == AvailabilityByPhone.SPECIFIC ? specific : null}

            <div className="text_big">{locale.msgs.HOW_FIND_US}</div>

            <div className="radio" id="recommendation">
                <DropdownMenu text="Wählen" options={Object.values(recTransList)}
                        value={recTransList[props.miscellaneous["recommendation"]]}
                        onValueChange={(value) => props.onMiscellaneousChange(
                            {...props.miscellaneous, "recommendation": recTransListInverse[value]})}
                        showPlaceholderIfNotEmpty={false}
                        onScroll={props.onScroll} />
            </div>
        </div>
    );
}

export function Done(props) {
    const locale = useContext(LocaleContext);
    const consumer = useContext(ConsumerContext);
    const login = useContext(LoginContext);

    return(
        !consumer.declined ?
            <div className="done">
                <div className="head">{locale.msgs.DONE}</div>

                <div className="text">{locale.msgs.DONE_DESCR.replace("${{notifications}}", get_translated_notifications(login.notifications, locale))}</div>
            </div>
        :
            null
    );
}

export function CollectDataError(props) {
    const locale = useContext(LocaleContext);

    const [searchParams, setSearchParams] = useSearchParams();
    const status = searchParams.get("status");

    return(
        <div className="done">
            <div className="head head_bar">{locale.msgs.COLLECT_DATA_FAILED}</div>

            {/* When adjusting the error code, do not forget to adjust 520 in component CollectData in handleBackwards() */}
            <div className="text">
                {status && status === "520" ?
                    locale.msgs.GEOCODE_ERROR_DESCR
                : status && status === "528" ?
                    locale.msgs.PHONE_NO_VERFICATION_FAILED_DESCR
                : 
                    locale.msgs.GENERAL_ERROR_DESCR}</div>
        </div>
    );
}
